(function () {
    if (window.__fbmCartCheckoutLoaded) return;
    window.__fbmCartCheckoutLoaded = true;

    console.log("[fbm] cart-checkout-btn.js loaded");

    var STORE_NAME = (window.Shopify && window.Shopify.shop) || "";
    var CART_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + "cart"
        : "/cart";
    var MAX_RETRIES = 5;
    var RETRY_DELAY = 500;
    var __fbmIsProcessing = false;
    // Shopify checkout lives at /checkout and /checkouts/... (with optional locale prefix).
    var CHECKOUT_PATH_RE = /\/checkouts?(\/|$)/;
    var CART_PATH_RE = /\/cart\/?$/;

    function getCookie(name) {
        var m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, "\\$1") + "=([^;]*)"));
        return m ? decodeURIComponent(m[1]) : "";
    }

    function getCartToken() {
        var raw = getCookie("cart") || "";
        return raw.split("?")[0].split("%3F")[0];
    }

    function fbmUuid() {
        if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // Cookie name `coco_sid` is the contract with the checkout backend
    // (decoded as `cocoSid` in the token JSON). DO NOT rebrand it — every
    // existing merchant install reads/writes that exact key, and the
    // server-side token decoder hard-references the same field name.
    function getOrCreateFbmSid() {
        var sid = getCookie("coco_sid");
        if (!sid) {
            sid = fbmUuid();
            var d = new Date();
            d.setTime(d.getTime() + 2592000000);
            document.cookie = "coco_sid=" + sid + "; expires=" + d.toUTCString() + "; path=/; SameSite=Lax";
        }
        return sid;
    }

    // Naive root-domain extraction: last two labels. Skips IPs/localhost and
    // does not handle PSL multi-label TLDs (.co.uk, .com.au) — those will fall
    // back to host-only cookies, which is safe (just no cross-subdomain share).
    function getRootDomainAttr() {
        var host = window.location.hostname;
        if (!host || host === "localhost" || /^[\d.]+$/.test(host)) return "";
        var parts = host.split(".");
        if (parts.length < 2) return "";
        return "." + parts.slice(-2).join(".");
    }

    function getUrlParam(name) {
        try {
            return new URLSearchParams(window.location.search).get(name) || "";
        } catch (e) {
            return "";
        }
    }

    function appendParam(url, key, value) {
        if (!value) return url;
        return url + (url.indexOf("?") !== -1 ? "&" : "?") + key + "=" + encodeURIComponent(value);
    }

    function setTrackingCookie(name, value) {
        if (!value) return;
        var d = new Date();
        d.setTime(d.getTime() + 2592000000);
        var attrs = "; expires=" + d.toUTCString() + "; path=/; SameSite=Lax";
        var domain = getRootDomainAttr();
        if (domain) attrs += "; Domain=" + domain;
        if (window.location.protocol === "https:") attrs += "; Secure";
        document.cookie = name + "=" + encodeURIComponent(value) + attrs;
    }

    // Last-click attribution: URL wins over cookie. When URL has a fresh value,
    // overwrite the cookie so later pageviews without params keep the latest ad.
    function readTrackingValue(name) {
        var urlVal = getUrlParam(name);
        if (urlVal) {
            setTrackingCookie(name, urlVal);
            return urlVal;
        }
        return getCookie(name);
    }

    var TRACKING_KEYS = [
        "ttclid", "ScCid", "fbclid",
        "utm_source", "utm_medium", "utm_campaign",
        "utm_adset", "utm_ad", "utm_id"
    ];

    // Pixel-set browser IDs. These never appear in URLs — read from cookie only.
    var PIXEL_COOKIE_KEYS = ["_fbp", "_ttp"];

    function captureTrackingFromUrl() {
        for (var i = 0; i < TRACKING_KEYS.length; i++) {
            var v = getUrlParam(TRACKING_KEYS[i]);
            if (v) setTrackingCookie(TRACKING_KEYS[i], v);
        }
    }

    // Read _fbc as-is, or synthesize from fbclid using Meta's expected format
    // `fb.1.<click_ts_ms>.<fbclid>`. Persist the synthesized value so later
    // events use the same click timestamp (avoids drift across pageviews).
    function readFbc() {
        var fbc = getCookie("_fbc");
        if (fbc) return fbc;
        var fbclid = getUrlParam("fbclid") || getCookie("fbclid");
        if (!fbclid) return "";
        var synth = "fb.1." + Date.now() + "." + fbclid;
        setTrackingCookie("_fbc", synth);
        return synth;
    }

    function appendTrackingParams(url) {
        var result = url;
        for (var i = 0; i < TRACKING_KEYS.length; i++) {
            var key = TRACKING_KEYS[i];
            var val = readTrackingValue(key);
            if (val) result = appendParam(result, key, val);
        }
        for (var j = 0; j < PIXEL_COOKIE_KEYS.length; j++) {
            var pkey = PIXEL_COOKIE_KEYS[j];
            var pval = getCookie(pkey);
            if (pval) result = appendParam(result, pkey, pval);
        }
        var fbc = readFbc();
        if (fbc) result = appendParam(result, "_fbc", fbc);
        return result;
    }

    captureTrackingFromUrl();

    function fbmFetchCart(attempt) {
        return fetch("/cart.js?_=" + Date.now(), {
            credentials: "same-origin",
            cache: "no-store",
            headers: {"Accept": "application/json"}
        }).then(function (res) {
            if (res.ok) return res.json();
            if (attempt < MAX_RETRIES) {
                return new Promise(function (resolve) {
                    setTimeout(function () {
                        resolve(fbmFetchCart(attempt + 1));
                    }, RETRY_DELAY * (attempt + 1));
                });
            }
            throw new Error("Cart unavailable (" + res.status + ")");
        }).catch(function (err) {
            if (attempt < MAX_RETRIES) {
                return new Promise(function (resolve) {
                    setTimeout(function () {
                        resolve(fbmFetchCart(attempt + 1));
                    }, RETRY_DELAY * (attempt + 1));
                });
            }
            throw err;
        });
    }

    function fbmBuildRedirectUrl(cart) {
        var productsURL = "";
        for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            var isBundle = it.discounts && it.discounts.length > 0 ? "ib" : "inb";
            productsURL += it.product_id + ";" + it.variant_id + ";" + it.quantity + ";" + it.final_price + ";" + isBundle + ";;";
        }

        var cartToken = getCartToken();
        var cleanDomain = window.location.hostname.replace(/^www\./, "");
        var fbmSid = getOrCreateFbmSid();

        // JSON field `cocoSid` is the contract with the checkout backend
        // (server-side token decoder hard-references this key). The value
        // is fbmSid; the field name stays for back-compat. DO NOT rename.
        var checkoutToken = btoa(JSON.stringify({
            shopUrl: STORE_NAME,
            cartToken: cartToken,
            c: cart.currency,
            productsURL: productsURL,
            isFromRecover: false,
            cocoSid: fbmSid
        }));

        // theme.liquid resolves the host from the primary domain, so visitors on
        // *.myshopify.com or a preview URL still land on the real pay. subdomain.
        var host = window.cocoCheckoutHost || ("pay." + cleanDomain);
        var url = "https://" + host + "/checkout/" + checkoutToken;
        url = appendParam(url, "sid", fbmSid);
        url = appendParam(url, "event_id", fbmUuid());
        url = appendParam(url, "event_source_url", window.location.href);
        return appendTrackingParams(url);
    }

    function fbmSetAllLoading(on) {
        var allBtns = document.querySelectorAll(".fbm-cart-checkout-trigger");
        for (var i = 0; i < allBtns.length; i++) {
            if (on) allBtns[i].classList.add("is-loading");
            else allBtns[i].classList.remove("is-loading");
        }
    }

    function fbmResetProcessing() {
        __fbmIsProcessing = false;
        fbmSetAllLoading(false);
    }

    function fbmProcessCheckout() {
        if (__fbmIsProcessing) return;
        __fbmIsProcessing = true;
        fbmSetAllLoading(true);
        // If the redirect stalls (slow network), let the shopper tap again.
        setTimeout(fbmResetProcessing, 15000);

        fbmFetchCart(0)
            .then(function (cart) {
                if (!cart || !cart.items || cart.items.length === 0) {
                    fbmSetAllLoading(false);
                    __fbmIsProcessing = false;
                    return;
                }
                var redirectUrl = fbmBuildRedirectUrl(cart);
                window.location.href = redirectUrl;
            })
            .catch(function (err) {
                console.error("[fbm] checkout failed", err);
                fbmSetAllLoading(false);
                __fbmIsProcessing = false;
                window.location.href = CART_URL;
            });
    }

    window.fbmProcessCheckout = fbmProcessCheckout;

    function sameOriginUrl(href) {
        try {
            var u = new URL(href, window.location.href);
            return u.origin === window.location.origin ? u : null;
        } catch (e) {
            return null;
        }
    }

    function isShopifyCheckoutUrl(href) {
        var u = sameOriginUrl(href);
        if (!u) return false;
        return CHECKOUT_PATH_RE.test(u.pathname) || (CART_PATH_RE.test(u.pathname) && u.searchParams.has("checkout"));
    }

    // A POST to /cart carrying `checkout` makes Shopify redirect to its own checkout.
    // The drawer's button sits outside its form (form= attribute), so check the
    // submitter and form.elements (which include form=-associated controls).
    function isCheckoutSubmit(e) {
        var form = e.target;
        if (!form || form.tagName !== "FORM") return false;
        var u = sameOriginUrl(form.action || "");
        if (!u) return false;
        if (CHECKOUT_PATH_RE.test(u.pathname)) return true;
        if (!CART_PATH_RE.test(u.pathname)) return false;
        if (u.searchParams.has("checkout")) return true;
        var s = e.submitter;
        if (s) return s.name === "checkout";
        var field = form.elements && form.elements.namedItem && form.elements.namedItem("checkout");
        return !!(field && field.type === "hidden");
    }

    function intercept(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        fbmProcessCheckout();
    }

    document.addEventListener("click", function (e) {
        if (!e.target.closest) return;
        // Always swallow the click, even mid-redirect: the drawer button is a native
        // submit, so letting a second tap through posts /cart?checkout to Shopify.
        if (e.target.closest(".fbm-cart-checkout-trigger")) return intercept(e);
        var link = e.target.closest("a[href]");
        if (link && isShopifyCheckoutUrl(link.href)) intercept(e);
    }, true);

    document.addEventListener("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        if (e.target.closest && e.target.closest(".fbm-cart-checkout-trigger")) intercept(e);
    }, true);

    document.addEventListener("submit", function (e) {
        if (isCheckoutSubmit(e)) intercept(e);
    }, true);

    // Catch-all for navigations no click/submit listener sees: form.submit(),
    // Shopify.postLink, location.href = "/checkout" from theme or app code.
    if (window.navigation && typeof window.navigation.addEventListener === "function") {
        window.navigation.addEventListener("navigate", function (e) {
            if (!e.cancelable || e.hashChange || e.downloadRequest) return;
            var u = sameOriginUrl(e.destination && e.destination.url);
            if (!u) return;
            var toCheckout = CHECKOUT_PATH_RE.test(u.pathname) ||
                (CART_PATH_RE.test(u.pathname) && (u.searchParams.has("checkout") || (e.formData && e.formData.has("checkout"))));
            if (!toCheckout) return;
            e.preventDefault();
            fbmProcessCheckout();
        });
    }

    // Back button from pay. restores this page from bfcache with the spinner still on.
    window.addEventListener("pageshow", function (e) {
        if (e.persisted) fbmResetProcessing();
    });

    // A checkout tap that the inline guard in theme.liquid held while this file loaded.
    if (window.__fbmPendingCheckout) {
        window.__fbmPendingCheckout = false;
        fbmProcessCheckout();
    }
})();
